export default "__VITE_ASSET__$FwdFT70__"